import LsdApiModel  from './global/LsdApiModel';
import { computed } from 'mobx';

export default class ProjectModel extends LsdApiModel {
	static get path(): string {
		return '/projects/{?id}';
	}

	@computed
	get budgetTarget() {
		return this.get('budgetTarget');
	}

	@computed
	get comment() {
		return this.get('comment');
	}

	@computed
	get description() {
		return this.get('description');
	}

	@computed
	get expenseGroupId() {
		return this.get('expenseGroup.id');
	}

	@computed
	get expenseGroupIri() {
		return this.get('expenseGroup.@id');
	}

	@computed
	get piloteIri() {
		return this.get('pilote.@id');
	}

	@computed
	get projectSubCategoryId() {
		return this.get('projectSubCategory.id');
	}

	@computed
	get projectSubCategoryIri() {
		return this.get('projectSubCategory.@id');
	}

	@computed
	get title() {
		return this.get('title');
	}
}
